import { Component } from '@angular/core';

@Component({
  selector: 'app-open10-info-component',
  imports: [],
  templateUrl: './open10-info-component.html',
  styleUrl: './open10-info-component.scss'
})
export class Open10InfoComponent {

}
